<template>
	<div>
		<div class="x-stat">
			<a-row>
				<a-col :span="3">
					<a-statistic title="数量" :value="totalRow" />
				</a-col>
			</a-row>
		</div>

		<a-card :bordered="false">
			<div class="x-filter">
				<a-form layout="inline">
					<a-row :gutter="24">
						<a-col :span="4">
							<a-form-item label="任务名称">
								<a-input v-model="queryParams.name" placeholder="名称" />
							</a-form-item>
						</a-col>
						<a-col :span="4">
							<a-form-item label="标识">
								<a-input v-model="queryParams.ident" placeholder="标识" />
							</a-form-item>
						</a-col>
						
						<template v-if="advanced">
							<a-col :span="4">
								<a-form-item label="受众">
									<a-select v-model="queryParams.audience" placeholder="请选择" default-value="">
										<a-select-option value="MALE">男</a-select-option>
										<a-select-option value="FEMALE">女</a-select-option>
									</a-select>
								</a-form-item>
							</a-col>
							
							<a-col :md="8">
								<a-form-item label="创建时间">
									<a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
								</a-form-item>
							</a-col>
						</template>
						<a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
								:style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="rest()">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
						</a-col>
					</a-row>
				</a-form>
			</div>

			<div class="x-tool">
				<a-button type="primary" icon="plus" v-has="'/content/taskAdd'" @click="add">新增</a-button>
			</div>

			<a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
				:dataSource="tableData" :pagination="false">
				
				<template slot="taskName" slot-scope="record" >
					<div class="task-info">
						<span>{{record.name}}</span>
						<span class="task-depict">{{record.depict}}</span>
					</div>
				</template>
				
				<template slot="type" slot-scope="record">
					<span v-if="record.type=='NEWBIE'">新手</span>
					<span v-else>日常</span>
				</template>

				<template slot="sex" slot-scope="record">
					<span v-if="record.sex=='MALE'">男</span>
					<span v-else>女</span>
				</template>

				<template slot="reward" slot-scope="record">
					<span>{{ rewardLabel(record) }}</span>
				</template>

				<template slot="action" slot-scope="record">
					<a v-has="'/content/taskUpdate'" @click="update(record)">修改</a>
				</template>
			</a-table>

			<Task-form-modal ref="TaskForm" :visible="TaskFormVisible" :loading="TaskFormLoading" :model="TaskFormModel"
				@cancel="TaskFormCancel" @ok="TaskFormOk" />

			<div class="x-pagination">
				<a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
					:hideOnSinglePage="true" show-less-items />
			</div>
		</a-card>
	</div>
</template>

<script>
	import moment from "moment";
	import TaskFormModal from "@/pages/content/task/TaskForm.vue";
	import {
		taskList,
		taskAdd,
		taskUpdate,
		taskSetEnable
	} from "@/api/content/task.js";

	const tableColumns = [{
			title: '#',
			dataIndex: 'id'
		},
		{
			title: '任务',
			scopedSlots: {
				customRender: 'taskName'
			}
		},
		{
			title: '标识',
			dataIndex: 'ident'
		},
		{
			title: '类型',
			scopedSlots: {
				customRender: 'type'
			}
		},
		{
			title: '受众',
			scopedSlots: {
				customRender: 'sex'
			}
		},
		{
			title: '奖励',
			scopedSlots: {
				customRender: 'reward'
			}
		},
		{
			title: '排序',
			dataIndex: 'seq'
		},
		{
			title: '创建时间',
			dataIndex: 'created'
		},
		{
			title: '操作',
			scopedSlots: {
				customRender: 'action'
			}
		}
	];

	export default {
		components: {
			TaskFormModal
		},
		data() {
			return {
				advanced: false,
				queryParams: {},
				totalRow: 0,
				tableColumns,
				tableData: [],
				tableLoading: false,
				pageSize: 20,
				pageIndex: 1,
				TaskFormVisible: false,
				TaskFormLoading: false,
				TaskFormModel: null,
				activeTime: [],
				createTime: [],
			}
		},
		created() {
			this.fetchTableData();
		},
		methods: {
			fetchTableData() {
				this.tableLoading = true;
				this.queryParams.pageSize = this.pageSize;
				this.queryParams.page = this.pageIndex;
				taskList(this.queryParams).then(res => {
					this.totalRow = res.data.totalRow;
					this.tableData = res.data.recordList;

					this.tableLoading = false;
				});
			},
			pageChange(current) {
				this.pageIndex = current;
				this.fetchTableData();
			},
			toggleAdvanced() {
				this.advanced = !this.advanced;
			},
			onCreateTime(values) {
				this.queryParams.startCreateTime = moment(values[0]).unix();
				this.queryParams.endCreateTime = moment(values[1]).unix();
			},
			onActiveTime(values) {
				this.queryParams.startActiveTime = moment(values[0]).unix();
				this.queryParams.endActiveTime = moment(values[1]).unix();
			},
			add() {
				this.TaskFormModel = null;
				this.TaskFormVisible = true;
				this.$nextTick(() => {
					if (this.$refs.TaskForm && this.$refs.TaskForm.initForm) {
						this.$refs.TaskForm.initForm();
					}
				});
			},
			update(record) {
				this.TaskFormModel = {
					...record
				};
				this.TaskFormVisible = true;
			},
			TaskFormOk() {
				const taskForm = this.$refs.TaskForm;
				if (!taskForm || !taskForm.$refs.adminForm) {
					return;
				}
				taskForm.$refs.adminForm.validate(valid => {
					if (!valid) {
						return;
					}
					const values = { ...taskForm.form };
					this.TaskFormLoading = true;
					if (values.id > 0) {
						const payload = {
							...this.TaskFormModel,
							reward: values.reward,
							seq: values.seq
						};
						taskUpdate(payload).then(() => {
							this.TaskFormAfter('修改任务成功');
						}).catch(() => {
							this.TaskFormLoading = false;
						});
					} else {
						taskAdd(values).then(() => {
							this.TaskFormAfter('新增任务成功');
						}).catch(() => {
							this.TaskFormLoading = false;
						});
					}
				});
			},
			TaskFormCancel() {
				this.TaskFormModel = null;
				this.TaskFormVisible = false;
				if (this.$refs.TaskForm && this.$refs.TaskForm.initForm) {
					this.$refs.TaskForm.initForm();
				}
			},
			TaskFormAfter(message) {
				this.TaskFormVisible = false;
				this.TaskFormLoading = false;
				if (this.$refs.TaskForm && this.$refs.TaskForm.initForm) {
					this.$refs.TaskForm.initForm();
				}
				this.fetchTableData();
				this.$message.success(message);
			},
			setEnable(id, enable) {
				taskSetEnable(id, enable).then(() => {
					this.fetchTableData();
					if (enable == 'Y') {
						this.$message.success(`任务:${id}，已启用`);
					} else {
						this.$message.success(`任务:${id}，已禁用`);
					}
				})
			},
			rest() {
				this.activeTime = [];
				this.createTime = [];
				this.queryParams = {}
			},
			rewardLabel(record) {
				const r = record.reward;
				if (r === undefined || r === null || r === '') {
					return '—';
				}
				if (record.sex == 'MALE') {
					return `${r} 金币`;
				}
				if (record.sex == 'FEMALE') {
					return `${r} 积分`;
				}
				return String(r);
			},
		}
	}
</script>

<style lang="less" scoped>
	.task-info {
		display: flex;
		flex-direction: column;
		
		.task-depict {
			font-size: 12px;
			color: #acacac;
		}
	}

</style>